const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const count = (number, unit) => `${number} ${unit}${number === 1 ? '' : 's'}`;

// How long a limited-time offer has left, as a short phrase for its banner:
// "Ends in 3 days", "Ends in 29 hours", "Ends in 1 hour 20 minutes", "Ends in
// 12 minutes". A week or more out it is simply the date, since a countdown
// that far off is not urgent. Returns '' when there is no usable end.
export const formatOfferTimeLeft = (expiresAt, now = Date.now()) => {
  const end = new Date(expiresAt).getTime();
  if (!expiresAt || !Number.isFinite(end)) return '';

  const left = end - now;
  if (left <= 0) return 'Ending now';
  if (left >= 7 * DAY) {
    const sameYear = new Date(end).getFullYear() === new Date(now).getFullYear();
    return `Ends ${new Date(end).toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'short',
      ...(sameYear ? {} : { year: 'numeric' })
    })}`;
  }
  if (left >= 2 * DAY) return `Ends in ${count(Math.floor(left / DAY), 'day')}`;
  if (left >= 3 * HOUR) return `Ends in ${count(Math.floor(left / HOUR), 'hour')}`;
  if (left >= HOUR) {
    const hours = Math.floor(left / HOUR);
    const minutes = Math.floor((left % HOUR) / MINUTE);
    return `Ends in ${count(hours, 'hour')}${minutes ? ` ${count(minutes, 'minute')}` : ''}`;
  }
  return `Ends in ${count(Math.max(1, Math.floor(left / MINUTE)), 'minute')}`;
};
